import { Holding } from './entities';
import { Subscribable } from '@benzinga/subscribable';
import { HoldingsRequestEvent } from './manager';
export class HoldingsStore extends Subscribable<HoldingsRequestEvent> {
  private indexHoldings: Holding[];
  constructor() {
    super();
    this.indexHoldings = [];
  }

  public compareHoldings = (lhs: Holding[], rhs: Holding[]): boolean => {
    if (lhs.length !== rhs.length) {
      return false;
    }
    return lhs.every(holding => {
      const newHolding = rhs.find(newHolding => holding.holdingName === newHolding.holdingName);
      if (newHolding) {
        return holding.holdingSymbols.length === newHolding.holdingSymbols.length;
      } else {
        return false;
      }
    });
  };

  public getCachedHoldingByIndexName = (indexName: string): Holding | undefined =>
    this.indexHoldings.find(holding => holding.holdingName === indexName);

  public getIndexStoreHoldings = (): Holding[] => {
    return this.indexHoldings ?? [];
  };

  public updateHoldings = (indexHoldings: Holding[]): Holding[] => {
    const areIndexHoldingsEqual = this.compareHoldings(this.indexHoldings, indexHoldings);
    if (areIndexHoldingsEqual) return indexHoldings;
    this.indexHoldings = indexHoldings;
    this.dispatch({
      indexHoldings,
      type: 'holdings:update_holdings',
    });
    return indexHoldings;
  };
}
